import { useEffect, useState } from "react";

export const useContentScrollbarWidth = (active: boolean = true): number => {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (!active) {
      setWidth(0);
      return;
    }

    const measure = () => {
      const main = document.querySelector("main");
      if (!main) {
        setWidth(0);
        return;
      }
      setWidth(main.offsetWidth - main.clientWidth);
    };

    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, [active]);

  return width;
};
